import { useAuth } from "@/shared/contexts/auth.context";
import { Navigate, Outlet, useLocation } from "react-router";
import React from "react";
import { useAccount } from "@/features/workspace/hooks/useAccount";
import { buildOrgRoute } from "@/shared/utils/router/useOrgNavigate";

function LandingRoute() {
  const { isAuthenticated } = useAuth();
  const { account } = useAccount();
  const location = useLocation();

  if (isAuthenticated) {
    const landingRoute =
      buildOrgRoute(account?.config?.landing_route || "/dashboard") || "/org";

    return (
      <Navigate
        to={{
          pathname: landingRoute,
          search: location.search,
        }}
        replace
      />
    );
  }

  return <Outlet />;
}

export default LandingRoute;
